export default __webpack_public_path__ + "static/media/slider.cc660f6b.jpeg";